import Vue, { PropOptions } from "vue";

import { componentRoleTypeMixins } from "./componentRoleTypeMixins";

export function getSummaryRoleComponentSelectorMixin(summaryRoute: string) {
  return Vue.extend({
    name: "SummaryRoleComponentSelector",

    mixins: [componentRoleTypeMixins()],

    props: {
      route: {
        type: String,
        default: () => summaryRoute,
      } as PropOptions<string>,
    },
  });
}
